<template>
    <div id="gallery" :style='[$vuetify.breakpoint.xs ? {"padding": "30px"} : {"padding": "50px"}]'>
        <b-overlay :show="process" no-wrap>
            <template v-slot:overlay>
                <img
                    src="../assets/images/logo anim.svg"
                    width="100px"
                    height="100px"
                />
            </template>
        </b-overlay>
        <h4>Student Gallery</h4>
        <div v-if="!(other.length || videos.length || photos.length)">No uploads.</div>
        <br />
        <b-modal size="lg" ref="modal-center" centered hide-footer :title="select.name">
            <div class="d-flex justify-content-center align-items-center">
                <img
                    class="imgt"
                    :src="select.link"
                    style="max-width:600px;max-height:600px"
                    :alt="select.name"
                />
            </div>
        </b-modal>
        <div id="photoView" v-if="photos.length">
            <h5>Photos</h5>
            <div class="row row-cols-4">
                <div
                    class="col d-flex align-items-center"
                    v-for="photo in photos"
                    v-bind:key="photo.name"
                >
                    <img
                        :src="photo.link"
                        :alt="photo.name"
                        width="200"
                        @click="showModal(photo)"
                    />
                </div>
            </div>
        </div>
        <br />
        <div id="videoView" v-if="videos.length">
            <h5>Videos</h5>
            <div class="row row-cols-3">
                <div
                    class="col d-flex align-items-center"
                    v-for="video in videos"
                    v-bind:key="video.name"
                >
                    <video :src="video.link" controls width="256" />
                </div>
            </div>          
        </div>
        <br />
        <div id="videoView" v-if="other.length">
            <h5>Other</h5>
            <ul>
                <li v-for="item in other" :key="item.name">
                    <a :href="item.link" target="_blank">{{item.name}}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");

export default {
    data() {
        return {
            select: { name: "", link: "" },
            process: true,
            photos: [],
            videos: [],
            other: []
        };
    },
    computed: {
        ...mapState(["userProfile", "promise"])
    },
    created: function() {
        Promise.resolve(this.promise).then(() => {
            this.getPhotos();
            this.getVideos();
            this.getOther();
        });
    },
    methods: {
        showModal(photo) {
            this.select = photo;
            this.$refs["modal-center"].show();
        },
        getPhotos() {
            const vue = this;
            const refPath = "photos/" + vue.userProfile.email + "/";
            const ref = fb.storageRef.child(refPath);
            ref.listAll().then(res => {
                var promises = [];
                res.items.forEach(itemRef => {
                    const prom = new Promise(resolve => {
                        fb.storageRef
                            .child(itemRef.fullPath)
                            .getDownloadURL()
                            .then(url => {
                                fb.storageRef
                                    .child(itemRef.fullPath)
                                    .getMetadata()
                                    .then(metadata => {
                                        const photo = {
                                            name: itemRef.name,
                                            link: url,
                                            timeCreated: metadata.timeCreated
                                        };

                                        vue.photos.push(photo);
                                        resolve();
                                    });
                            });
                    });
                    promises.push(prom);
                });
                Promise.all(promises).then(() => {
                    vue.photos.sort(function(a, b) {
                        return -(
                            Date.parse(a.timeCreated) -
                            Date.parse(b.timeCreated)
                        );
                    });
                    vue.process = false;
                });
            });
        },
        getVideos() {
            const vue = this;
            const refPath = "videos/" + vue.userProfile.email + "/";
            const ref = fb.storageRef.child(refPath);
            ref.listAll().then(res => {
                var promises = [];
                res.items.forEach(itemRef => {
                    const prom = new Promise(resolve => {
                        fb.storageRef
                            .child(itemRef.fullPath)
                            .getDownloadURL()
                            .then(url => {
                                fb.storageRef
                                    .child(itemRef.fullPath)
                                    .getMetadata()
                                    .then(metadata => {
                                        const video = {
                                            name: itemRef.name,
                                            link: url,
                                            timeCreated: metadata.timeCreated
                                        };

                                        vue.videos.push(video);
                                        resolve();
                                    });
                            });
                    });
                    promises.push(prom);
                });
                Promise.all(promises).then(() => {
                    vue.videos.sort(function(a, b) {
                        return -(
                            Date.parse(a.timeCreated) -
                            Date.parse(b.timeCreated)
                        );
                    });
                    vue.process = false;
                });
            });
        },
        getOther() {
            const vue = this;
            const refPath = "other/" + vue.userProfile.email + "/";
            const ref = fb.storageRef.child(refPath);
            ref.listAll().then(res => {
                var promises = [];
                res.items.forEach(itemRef => {
                    const prom = new Promise(resolve => {
                        fb.storageRef
                            .child(itemRef.fullPath)
                            .getDownloadURL()
                            .then(url => {
                                fb.storageRef
                                    .child(itemRef.fullPath)
                                    .getMetadata()
                                    .then(metadata => {
                                        const item = {
                                            name: itemRef.name,
                                            link: url,
                                            timeCreated: metadata.timeCreated
                                        };

                                        vue.other.push(item);
                                        resolve();
                                    });
                            });
                    });
                    promises.push(prom);
                });
                Promise.all(promises).then(() => {
                    vue.other.sort(function(a, b) {
                        return -(
                            Date.parse(a.timeCreated) -
                            Date.parse(b.timeCreated)
                        );
                    });
                    vue.process = false;
                });
            });
        }
    }
};
</script>